import React, { useState, useEffect } from 'react'

import styled from 'styled-components'

import { MultiSelect } from '../Select'
import SkillRangeSlider from './components/SkillRangeSlider'

import apiClient from '../../helpers/apiClient'

const TechnicalSkillInput = ({
  skills,
  professionalHeadlineIds = [],
  onSelectTechnicalSkills,
  fieldError,
}) => {
  const [technicalSkillList, setTechnicalSkillList] = useState([])
  const [updatedSkills, setUpdatedSkills] = useState([])

  useEffect(() => {
    setUpdatedSkills(
      skills?.map((e) => ({
        ...e,
        label: e?.skill,
        value: e?.id,
      }))
    )
  }, [skills])

  useEffect(() => {
    apiClient
      .get(
        `/technical-skills?professionalHeadline_id=${JSON.stringify(
          professionalHeadlineIds
        )}`
      )
      .then((res) => {
        const result = res?.data?.resp

        const uniqueSkillsMap = new Map()

        result.forEach((e) => {
          if (!uniqueSkillsMap.has(e.skills)) {
            uniqueSkillsMap.set(e.skills, e.id)
          }
        })

        const formattedTechnicalSkills = [...uniqueSkillsMap].map(
          ([skills, id]) => ({
            label: skills,
            value: id,
          })
        )

        setTechnicalSkillList(formattedTechnicalSkills)
      })
      .catch((err) => console.log(err))
  }, [])

  return (
    <TechnicalSkillInputContainer>
      <MultiSelect
        title="Technical Skills"
        options={technicalSkillList}
        selected={updatedSkills}
        placeholder="Select Technical Skills"
        onChange={onSelectTechnicalSkills}
        wrapperClass={fieldError && 'error'}
        subText={fieldError}
      />

      <SkillRangeSlidersContainer>
        {updatedSkills?.map(({ label, experience, value }, index) => (
          <SkillRangeSlider
            key={index}
            skill={label}
            experience={parseInt(experience)}
            id={value}
            setSkills={onSelectTechnicalSkills}
            skills={updatedSkills}
          />
        ))}
      </SkillRangeSlidersContainer>
    </TechnicalSkillInputContainer>
  )
}

const TechnicalSkillInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1rem;
`

const SkillRangeSlidersContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2.5rem;
  }
`

export default TechnicalSkillInput
